<template>
  <div id="nom_intro_winners_period">
    
    <h4>Nominations are currently closed</h4>

    <p>
      But good news: <strong>the winners have been announced!</strong>
    </p>

    <p>
      Use the big button below to head on over to our "winners" section to find out if your finalists won.
    </p>

  </div>
</template>

<script>

export default {
  name: 'nom_intro_winners_period',
  props: [
    'nom_start_date',
    'tz_offset'
  ],
  data () {
    return {
      
    }
  },
  computed: {
    
  },
  methods: {

  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.iframe_container {
  margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// src/features/nominate/intros/nom_intro_winners_period.vue